// styles
import { CardAttributeContainer } from "./CardAttribute.styles"

export default function CardAttribute({ color = null, text, size = "S", onClick }) {
    return (
        <CardAttributeContainer size={size} color={color} $clickable={!!onClick} onClick={onClick}>
            {text}
        </CardAttributeContainer>
    )
}
